import { useAmp } from 'next/amp';

function DetectAmp({ children }) {
  return children(useAmp());
}

export default DetectAmp;
